module.exports = __webpack_public_path__ + "img/novos-talentos-inscreva-se.a0f3ae2f.png";